import * as BaseApi from "api/Base.api";
import { IBbs } from "api/interfaces/bbs.interface";
import { IPagination } from "api/interfaces/common.interface";

//* 홈 정보 조회    
//  2025.03.04
//  희문
//* Params
//  none
export const fetchHomeInfo = async () => {
    console.log("api/student/v2/home.api:fetchHomeInfo");
    const url = "/student/v2/home";
    return await BaseApi.get(url);
};


//* 타임라인 목록 조회
//* Params
//  page: number
//  subject: string
export interface IHomeTimelineListResponse {
    list: IBbs[];
    pagination: IPagination;
}
export const fetchTimelineList = async (page: number, subject: string): Promise<IHomeTimelineListResponse> => {
    console.log("api/student/v2/home.api:fetchTimelineList");
    console.log({ page, subject });
    let url = `/student/v2/home/timeline`;
    return await BaseApi.get(url, { page, subject });
};